<template>
  <div
    class="c-zoom-bar__wrapper"
    :class="{ 'c-zoom-bar__wrapper--expanded': showZoomLevel }"
    v-click-outside="{
      exclude: ['zoompicker'],
      handler: 'closeZoomLevel',
    }"
    @keyup.esc="closeZoomLevel"
  >
    <book-zoom-picker
      ref="zoompicker"
      v-show="showZoomLevel"
      :zoom-level="zoomLevel"
      :fit-to-window="fitToWindow"
      @change-zoom="setZoomLevel($event)"
      @fit-window-clicked="setZoomLevelFit()"
    />
    <book-zoom-item
      type="zoom-pick"
      :tooltip="$t('ZOOM_CHANGE')"
      @zoom-icon-clicked="toggleZoomLevel()"
    >
      {{ zoomLevel || '' }} %
      <arrow-icon />
    </book-zoom-item>
    <book-zoom-item
      type="zoom-out"
      :tooltip="$t('ZOOM_OUT')"
      @zoom-icon-clicked="decreaseZoomLevel()"
    >
      <zoom-out-icon />
    </book-zoom-item>
    <book-zoom-item
      type="zoom-in"
      :tooltip="$t('ZOOM_IN')"
      @zoom-icon-clicked="increaseZoomLevel()"
    >
      <zoom-in-icon />
    </book-zoom-item>
  </div>
</template>

<script>
import BookZoomItem from '@/components/BookZoomItem'
import BookZoomPicker from '@/components/BookZoomPicker'
import ZoomInIcon from '@/assets/svg/ZoomIn'
import ZoomOutIcon from '@/assets/svg/ZoomOut'
import Arrow from '@/assets/svg/Arrow'
import { mapState } from 'vuex'

export default {
  name: 'BookZoomBar',

  components: {
    'arrow-icon': Arrow,
    'book-zoom-item': BookZoomItem,
    'book-zoom-picker': BookZoomPicker,
    'zoom-in-icon': ZoomInIcon,
    'zoom-out-icon': ZoomOutIcon,
  },

  computed: {
    ...mapState('userSettings', {
      zoomLevel: state => state.zoomLevel,
    }),
  },

  data() {
    return {
      showZoomLevel: false,
    }
  },

  methods: {
    toggleZoomLevel() {
      this.showZoomLevel = !this.showZoomLevel
    },

    closeZoomLevel() {
      this.showZoomLevel = false
    },

    setZoomLevel(zoom) {
      this.closeZoomLevel()
      this.$emit('update-zoom-level', parseInt(zoom))
    },

    setZoomLevelFit() {
      this.closeZoomLevel()
      this.$emit('fit-window')
    },

    decreaseZoomLevel() {
      let zoom = this.zoomLevel

      if (zoom > 50) {
        zoom -= 10
        this.$emit('update-zoom-level', parseInt(zoom))
      }
    },

    increaseZoomLevel() {
      let zoom = this.zoomLevel

      if (zoom < 200) {
        zoom += 10
        this.$emit('update-zoom-level', parseInt(zoom))
      }
    },
  },

  props: {
    fitToWindow: Boolean,
  },
}
</script>

<style lang="scss">
.c-zoom-bar__wrapper {
  position: fixed;
  bottom: 66px;
  right: 16px;
  width: 90px;
  z-index: 10;
  transition: 0.2s width;

  &--expanded {
    width: 160px;
  }

  @media (max-width: 700px) {
    bottom: 122px;
  }
}
</style>
